'use client'

import { useEffect } from 'react'
import { onMessage } from 'firebase/messaging'
import { getFcmToken } from '@/src/firebase/getFcmToken'
import { getFirebaseMessaging } from '@/src/firebase/firebase'

function showNotification(title: string, body: string) {
    if (Notification.permission !== 'granted') return
    new Notification(title, { body })
}

export default function FcmTokenInitializer() {
    useEffect(() => {
        let unsubscribe: (() => void) | undefined

        async function init() {
            const token = await getFcmToken()
            if (!token) return

            const messaging = await getFirebaseMessaging()
            if (!messaging) return

            unsubscribe = onMessage(messaging, (payload) => {
                const { title, body } = payload.notification ?? {}
                showNotification(title ?? 'Notification', body ?? '')
            })
        }

        init().catch(console.error)

        return () => unsubscribe?.()
    }, [])

    return null
}
